// Returns a Coffeescript-like generator which, when called, returns the
// next elements in the given array, or if it hits the end, starts from the
// beginning.

const circularise = (array: any[], start_at: number) => {
  let current_index = start_at
  return {
    next: () => {
      return { value: array[ current_index++ % array.length ] }
    },
  }
}

export default circularise
